enum AccountType {
  FREEMIUM = 'FREEMIUM',
  DATA_PARTNER = 'DATA_PARTNER',
  PREMIUM = 'PREMIUM'
}

export default AccountType;
